/**
 * ReferralRock query to cookie mapping.
 */
import { referralMedium } from '@linqpal/models/src/dictionaries'

export const referralRock = {
  referralCode: {
    queryName: 'REFERRALCODE',
    cookieName: 'referral-rock-referral'
  },
  medium: {
    queryName: referralMedium.queryName,
    cookieName: 'referral-rock-medium'
  }
}
